export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-16">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">
          Terms of Service
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 space-y-8">
          {/* Acceptance of Terms */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              By accessing and using the Rondanini Publishing learning platform (the "Site"), you
              accept and agree to be bound by the terms and provision of this agreement. If you do
              not agree to abide by the above, please do not use this service.
            </p>
          </section>

          {/* License to Use */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              2. License to Use Content
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Rondanini Publishing grants you a limited, non-exclusive, non-transferable license to:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Access and view educational modules for personal use</li>
              <li>Download PDF copies of purchased modules</li>
              <li>Use Python code examples provided in modules</li>
              <li>Print modules for personal study purposes</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 mt-4">
              You may NOT:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Distribute, share, or resell purchased content</li>
              <li>Remove copyright notices or ownership information</li>
              <li>Use content for commercial purposes without permission</li>
              <li>Create derivative works from the content</li>
              <li>Bypass access controls or authentication</li>
            </ul>
          </section>

          {/* Intellectual Property */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              3. Intellectual Property Rights
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              All content on the Site, including text, graphics, logos, images, audio, video, and
              software, is the property of Rondanini Publishing Ltd or its content suppliers and is
              protected by international copyright laws. All rights are reserved. Unauthorized
              reproduction is prohibited.
            </p>
          </section>

          {/* User Accounts */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              4. User Accounts and Registration
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              When you create an account, you agree to:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Provide accurate, complete, and current information</li>
              <li>Maintain the confidentiality of your password</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Immediately notify us of unauthorized access</li>
              <li>Not create accounts for fraudulent or illegal purposes</li>
            </ul>
          </section>

          {/* Payment Terms */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              5. Payment and Refunds
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  Payment Terms
                </h3>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
                  <li>All prices are displayed in GBP (£)</li>
                  <li>VAT is calculated based on billing location</li>
                  <li>Invoices are generated automatically after purchase</li>
                  <li>Payment is processed via Stripe (PCI-DSS compliant)</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  Refund Policy
                </h3>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
                  <li>Refunds available within 30 days of purchase</li>
                  <li>Content must not have been downloaded or used extensively</li>
                  <li>Bulk purchase discounts are non-refundable as a bundle</li>
                  <li>Physical book pre-orders cannot be cancelled after payment</li>
                  <li>To request a refund, contact: <a href="mailto:support@rondanini.com" className="text-navy-600 dark:text-navy-400 hover:underline">
                    support@rondanini.com
                  </a></li>
                </ul>
              </div>
            </div>
          </section>

          {/* Limitations of Liability */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              6. Limitations of Liability
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              TO THE FULLEST EXTENT PERMITTED BY LAW:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Rondanini Publishing is not liable for any indirect, incidental, or consequential damages</li>
              <li>Our liability is limited to the amount you paid for the purchased content</li>
              <li>We provide content "as-is" without warranties of accuracy or fitness for purpose</li>
              <li>You assume all risks of using the Site and its content</li>
            </ul>
          </section>

          {/* Disclaimer */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              7. Disclaimer
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              The educational content provided on this Site is for informational and educational
              purposes only. It should not be construed as financial advice, investment
              recommendations, or professional guidance. Always consult with qualified professionals
              before making financial decisions. Past performance does not guarantee future results.
            </p>
          </section>

          {/* Acceptable Use */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              8. Acceptable Use Policy
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              You agree NOT to:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
              <li>Use the Site for illegal or unauthorized purposes</li>
              <li>Attempt to hack, crack, or bypass security measures</li>
              <li>Upload viruses, malware, or harmful code</li>
              <li>Engage in harassment, abuse, or threatening behavior</li>
              <li>Scrape or automatically collect Site data</li>
              <li>Interfere with servers or networks</li>
              <li>Share account credentials with others</li>
              <li>Create multiple accounts to abuse discounts or refunds</li>
            </ul>
          </section>

          {/* Termination */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              9. Termination
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              Rondanini Publishing may terminate or suspend your account immediately, without notice,
              if you violate these Terms of Service. Upon termination:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mt-4">
              <li>Your access to all content is revoked</li>
              <li>You retain no rights to the content</li>
              <li>Any pending refunds are forfeited</li>
            </ul>
          </section>

          {/* Third-Party Links */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              10. Third-Party Links
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              The Site may contain links to external websites. We are not responsible for the content,
              accuracy, or practices of third-party sites. Your use of third-party services is governed
              by their own terms and privacy policies.
            </p>
          </section>

          {/* Governing Law */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              11. Governing Law
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              These Terms of Service are governed by and construed in accordance with the laws of the
              United Kingdom, without regard to its conflict of law principles. Any legal action or
              proceeding shall be brought exclusively in the courts of the United Kingdom.
            </p>
          </section>

          {/* Dispute Resolution */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              12. Dispute Resolution
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Before pursuing legal action, we encourage you to contact us to resolve disputes:
            </p>
            <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-6 space-y-2">
              <p className="text-gray-700 dark:text-gray-300">
                <strong>Email:</strong> <a href="mailto:support@rondanini.com" className="text-navy-600 dark:text-navy-400 hover:underline">
                  support@rondanini.com
                </a>
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                <strong>Response Time:</strong> We will respond within 14 business days
              </p>
            </div>
          </section>

          {/* Modifications */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              13. Modifications to Terms
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              We reserve the right to modify these Terms of Service at any time. Changes are effective
              immediately upon posting to the Site. Your continued use of the Site constitutes your
              acceptance of any modifications.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              14. Contact Information
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              For questions regarding these Terms of Service:
            </p>
            <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-6 mt-4 space-y-2">
              <p className="text-gray-700 dark:text-gray-300">
                <strong>Email:</strong> <a href="mailto:legal@rondanini.com" className="text-navy-600 dark:text-navy-400 hover:underline">
                  legal@rondanini.com
                </a>
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                <strong>Website:</strong> www.rondanini.com
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
